import { useCallback, useMemo, useState } from "react";
import { useApiErrorDialog } from "../../../../../hooks/utile/use-error-dialog";
import { useParamState } from "../../../../../hooks/utile/use-param-state";
import { useValidation } from "../../../../../hooks/utile/use-validation";
import { Api } from "../../../../../module/api";
import { PasswordChangeRequestParam } from "../../../../../module/api/routes/password/change";
import { InputUtile } from "../../../../../module/utile/input-rurules";
import RootStore from "../../../../../store/root.store";
import { CustomButton } from "../../../button/button";

const initialPasswordChangeState: PasswordChangeRequestParam = {
  current_password: '',
  password: '',
  password_confirmation: '',
}

type Props = {
  onComplete: () => void,
  onCancel: () => void,
}

export const usePasswordChange = (props: Props) => {
  const {
    onComplete,
    onCancel,
  } = props;
  const { dialog } = RootStore;
  const [load, setLoad] = useState(false);
  const [request, setRequest] = useParamState(initialPasswordChangeState, {
    current_password: InputUtile.eisu,
    password: InputUtile.eisu,
    password_confirmation: InputUtile.eisu,
  });
  const errDialog = useApiErrorDialog();
  const { validAll } = useValidation();

  const validation = useMemo(() => {
    const {
      current_password,
      password,
      password_confirmation,
    } = request;
    return {
      current_password: validAll(current_password, 'require', 'length256', 'lengthOver8', 'password'),
      password: validAll(password, 'require', 'length256', 'lengthOver8', 'password'),
      password_confirmation: validAll(password_confirmation, 'require', 'length256', 'lengthOver8', 'password'),
    }
  }, [request, validAll]);

  const isDisabled = useMemo(() => {
    return !!Object.values(validation).flat().length;
  }, [validation]);

  const onClickSubmit = useCallback(() => {
    /* 確認用との突合のみ、通信前にクライアントで判定する */
    if (request.password !== request.password_confirmation) {
      dialog.pushMessage({
        messages: ['確認用パスワードが一致しません。', '入力内容をご確認ください。'],
        buttons: [
          { label: 'OK', callback: () => dialog.pop() },
        ],
      });
      return;
    }
    setLoad(true);
    Api.connect().password().change().put(request)
    .then(() => {
      dialog.pushMessage({
        messages: ['パスワードの変更が完了しました。'],
        buttons: [
          { label: 'OK', callback: onComplete },
        ],
      })
    }).catch((e) => errDialog.push(e))
    .finally(() => setLoad(false));
  }, [request, dialog, errDialog, onComplete]);

  const Footer = () => {
    return (
      <>
        <CustomButton
          colorType="secondary"
          onClick={onCancel}
          isDisabled={load}
        >
          キャンセル
        </CustomButton>
        <CustomButton
          onClick={onClickSubmit}
          isDisabled={isDisabled || load}
        >
          OK
        </CustomButton>
      </>
    )
  }

  return {
    Footer,
    request,
    setRequest,
    validation,
  }
}
